export default __webpack_public_path__ + "static/char-s-03-jp-dbe6d6e22e19a966c386efa9b158f438.png";